import { Module } from '../Module';
import { ExternalAuthService } from '../services/ExternalAuthService';
import { ServerService } from '../services/ServerService';

export interface ISignedOutScope extends ng.IScope {
  tryAgainLink: string;
}

export class SignedOutCtrl {

  public static $inject = [
    '$scope',
    '$state',
    'ExternalAuthService',
    'ServerService'
  ];

  constructor(
    $scope: ISignedOutScope,
    $state: ng.ui.IStateService,
    externalAuthService: ExternalAuthService,
    server: ServerService
  ) {
    $scope.tryAgainLink = server.isAuthenticationExternal() && !(server.isSiteSamlEnabled() && server.isServerDomainFamilyLocal()) ?
      externalAuthService.getLoginUrl() :
      $state.href('login.authenticate');
  }

}

Module.instance().controller('SignedOutCtrl', SignedOutCtrl);
